import { render } from "./AboutUsView.vue?vue&type=template&id=af1acb8e&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"

import "./AboutUsView.vue?vue&type=style&index=0&id=af1acb8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1acb8e"]])

export default __exports__